import { createUseStyles } from 'react-jss';
import colors from "../../utils/colors";

var styles = {
  zipCodeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  },
  zipTopWrapper: {
    position: 'relative',
    display: 'flex',
    marginBottom: '3rem'
  },
  zipCode: {
    // in case the zip and state has "small" size, and the county "large"
    marginRight: '7%'
  },
  errorMessage: {
    color: colors.red[500],
    fontSize: '1.2rem',
    marginLeft: '0.4rem',
    letterSpacing: '0.02rem'
  },
  validationIcon: {
    verticalAlign: '-0.18rem'
  },
  validationBlock: {
    bottom: '-2.5rem',
    position: 'absolute'
  },
  errorField: {
    '& input, & input:focus': {
      border: "1px solid ".concat(colors.red[500])
    }
  },
  spinnerWrapper: {
    position: 'absolute',
    height: '100%',
    width: '65%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(255,255,255,0.5)'
  },
  editButton: {
    textTransform: 'uppercase',
    marginLeft: '1.2rem',
    marginTop: '0.4rem',
    position: 'absolute',
    top: '25%',
    right: '10%'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map